export enum CanvasTypes {
    BACKGROUND = 'background',
    IMAGE = 'image',
    TEXT = 'text',
    FRAME = 'frame',
    INSTANCE = 'instance',
  }

export default CanvasTypes;
